import React from "react";
import '../add_campaign/styles.css'

export default function RegulerInformation() {
  return (
    <div className="container-info mt-3">
      <div style={{ fontSize: 14, fontWeight: "600" }}>Keterangan</div>
      <div style={{ marginTop: 24 }}>
        <div className="d-flex">
          <div style={{ flex: 1 }}>1.</div>
          <div style={{ flex: 20 }}>
            Untuk membuat promo baru, harus ada reguler offer terlebih dahulu
            untuk kategori produk, cabang, jenis pembayaran, jenis tenor, dan
            juga tenor yang akan dibuat.
          </div>
        </div>
        <div className="d-flex">
          <div style={{ flex: 1 }}>2.</div>
          <div style={{ flex: 20 }}>
            Reguler offer hanya berlaku untuk jenis tenor reguler.
          </div>
        </div>
        <div className="d-flex">
          <div style={{ flex: 1 }}>3.</div>
          <div style={{ flex: 20 }}>
            Tenor per Pinjaman adalah jangka waktu untuk satu kali masa
            pinjaman.
          </div>
        </div>

        <div className="d-flex">
          <div style={{ flex: 1 }}>4.</div>
          <div style={{ flex: 20 }}>
            Satu kali masa pinjaman maksimal 120 hari (4 bulan), sehingga sistem
            akan otomatis membagi masa pinjaman per 120 hari dari total hari
            yang dimasukkan.
          </div>
        </div>
        <div className="d-flex">
          <div style={{ flex: 1 }}>5.</div>
          <div style={{ flex: 20 }}>
            Maksimum Perpanjangan adalah batas pengajuan menambah tenor / masa
            pinjaman.
          </div>
        </div>
        <div className="d-flex">
          <div style={{ flex: 1 }}>6.</div>
          <div style={{ flex: 20 }}>
            Loan to Value (Maksimum Pinjaman) digunakan untuk menghitung batas
            tertinggi pinjaman yang boleh diminta oleh nasabah.
          </div>
        </div>
        <div className="d-flex">
          <div style={{ flex: 1 }}>7.</div>
          <div style={{ flex: 20 }}>
            Minimum Pinjaman digunakan untuk menghitung batas terendah pinjaman
            yang boleh diminta oleh nasabah.
          </div>
        </div>
      </div>
    </div>
  );
}
